import React from 'react';
import { MnLoading } from '../../../index';
import { Layout } from '../organisms/index';
import SimpleFormat from '@16g/react-simple-format';
import ReactMarkdown from 'react-markdown/with-html';

export default class RegionalMedicalCooperationTermShow extends React.Component {
  text = `
この利用規約（以下「本規約」といいます。）には、株式会社メディカルノート（以下「当社」といいます。）の提供する本サービスのご利用にあたり、利用者である医療関係者（以下「利用者」という。）の皆様に遵守していただかなければならない事項及び当社と利用者の皆様との間の権利義務関係が定められております。本サービスをご利用になる方は、本規約に同意する前に、必ず全文お読み下さいますようお願い致します。
### 第1条（適用）
- 本規約は、本サービスの利用に関する当社と利用者との間の権利義務関係を定めることを目的とし、利用者の皆様と当社の間の本サービスの利用に関わる一切の関係に適用されます。
- 当社が当社ウェブサイト上で随時掲載する本サービスに関するルール、諸規定等は本規約の一部を構成するものとします。

### 第2条（定義）
本規約において使用する以下の用語は各々以下に定める意味を有するものとします。
- 「本サービス」とは、当社が提供する次のサービス（理由の如何を問わずサービスの名称または内容が変更された場合は、当該変更後のサービスを含む。）を意味します。
  - Hospital Manager（地域連携）
- 「利用者」とは、本サービスを利用して紹介、逆紹介等の医療に関する連携関係を構築する医療機関等の医療関係者を意味します。
- 「医療関係者」とは、医師、歯科医師、薬剤師、看護師、臨床検査技師及び病院事務員等を意味します。
- 「契約医療機関」とは、当社とサービス利用契約（契約名称が変更された場合は、当該変更後の契約名称を含む。）を締結した医療機関その他の法人であり、診療等に従事する者を意味します。
- 「連携診療所」とは、紹介、逆紹介等の医療に関する連携関係を構築する医療機関等を意味します。
- 「データ等」とは、本サービスに保存される一切の情報（医療機関情報、医師情報、連携診療所間で提供される個人情報及び診療情報等、その他のデータを含みますがこれらに限りません。）を意味します。
  
### 第3条（本サービスの利用）
- 利用者は、本規約に従って、当社の定める方法に従い、本サービスを利用することができます。
- 利用者は、本サービスの利用にあたり、本サービス提供ページ上に入力した情報の内容について一切の責任を負うものとします。また、利用者は本サービス上で自ら作成・保存したデータおよび契約医療機関又は連携診療所が本サービスを経由して利用者に提供したデータの保管およびバックアップについては自ら責任を負うものとします。
- 利用者は、自らの責任と費用において、本サービスの利用に必要な環境（ハードウェア、ソフトウェア、インターネット接続回線、セキュリティーの確保等）を整備するものとします。

### 第４条（予約・診療等）
- 利用者は、本サービス提供ページを通じて、契約医療機関に対し、診療等の予約をすることができます。
- 利用者は、診療等の予約にあたり、本サービス提供ページ上に必要な情報を入力するものとします。
- 利用者は、利用者が本サービス提供ページを通じて契約医療機関に対し診療等の予約をした場合、本サービスの利用にあたり利用者が入力した情報が、当該契約医療機関に共有されることについて同意するものとします。
- 利用者が第1項に従って診療等の予約をし、前項に基づき契約医療機関に対して利用者の入力情報が通知された時点で、利用者と当該契約医療機関との間で本サービス提供ページ記載の内容にしたがって診療等に関する予約が完了するものとします。ただし、契約医療機関が当該予約を応諾しない場合は、この限りではありません。
- 診療等に関する問い合わせ、苦情、請求、紛争等については、利用者と契約医療機関及び所属医師等との間で解決するものとします。当社は、これらの紛争等について一切責任を負うことなく、また、その解決に関与する義務を負わないものとします。

### 第５条（利用者の個人情報の利用目的）
- 当社は、利用者及び利用者の患者様の個人情報を次の目的で利用します。
  - 本サービス及び契約医療機関での診療等を提供するために利用します。
  - 本サービスの利用動向を把握する目的で、利用者情報及び利用者の利用状況の統計分析を行います。この分析結果は、利用者の個人情報として契約医療機関に提供します。
  - 第三者が運営するデータ・マネジメント・プラットフォーム（Googleアナリティクスを含みますが、これに限られません）からCookie等により収集したウェブの閲覧履歴及びその分析結果を取得し、これを利用者の個人情報と結び付けたうえで、利用者属性把握等の目的で利用します。また、この情報は、利用者の個人情報として契約医療機関に提供します。
- 当社は、本サービスにおいてデータ等をモニタリングし、本サービスの提供及び運用実績を取得し統計処理いたします。当該実績及び統計処理の情報は当社に帰属し、法令等に従い公表する場合があります。

### 第６条（禁止行為）
- 利用者は、本サービスの利用にあたり、以下の各号のいずれかに該当する行為をしてはなりません。
  - 医療法、及び厚生労働省の「医療広告ガイドライン」及びその他の法令、ガイドライン規程等に違反する行為
  - 当社、契約医療機関又はその他の第三者の知的財産権、肖像権、プライバシーの権利、名誉、その他の権利又は利益を侵害する行為（かかる侵害を直接又は間接に惹起する行為を含みます。）
  - 本サービスの利用以外の目的で利用する行為
  - 第三者に本サービスを利用させる行為
  - 第三者の個人情報や履歴情報及び属性情報などを、当該第三者に無断で収 集・蓄積する行為
  - 本サービスと同種又は類似するサービスを開発し、又は運営する行為
  - 犯罪行為に関連する行為又は公序良俗に反する行為
  - 猥褻な情報又は青少年に有害な情報を送信する行為
  - 異性交際に関する情報を送信する行為
  - 法令若しくは当社又は利用者が所属する業界団体の内部規則に違反する行為
  - コンピューター・ウィルスその他の有害なコンピューター・プログラムを含む情報を送信する行為
  - 本サービスに関し利用しうる情報を改ざんする行為
  - 当社が定める一定のデータ容量以上のデータを本サービスを通じて送信する行為
  - 当社による本サービスの運営を妨害するおそれのある行為
  - 他人の名誉・信用等を侵害する行為
  - 事実に反する情報を提供する行為
  - 宗教活動、政治活動などの目的で本サービスを利用する行為
  - 当社の運営するウェブサイトのコンテンツを、当社以外の者が運営する広告媒体（バナー広告、リスティング広告等、広告の種類は問いません。）へ掲載する行為
  - その他、当社が不適切と判断する行為
- 当社は、本サービスにおける利用者の行為が前項各号のいずれかに該当し、又は該当するおそれがあると当社が判断した場合には、利用者に事前に通知することなく、当該利用者の本サービスの利用を一時停止することができるものとします。当社は、本項により当社が行った措置に基づき利用者に生じた損害について当社の故意又は重大な過失がある場合を除き、一切の責任を負わず、行った措置に関する理由について開示する義務を負いません。

### 第７条（暴力団等の反社会的勢力の排除）
- 利用者は、本サービスの利用に際して、自身が暴力団、暴力団員、暴力団関係企業、総会屋、社会運動標ぼうゴロ、政治運動標ぼうゴロ、特殊知能暴力集団、その他反社会的勢力（以下「暴力団等反社会的勢力」といいます。）に所属又は該当せず、かつ、暴力団等反社会的勢力と関与していないことを表明し、将来にわたっても所属若しくは該当、又は関与しないことを確約するものとします。
- 当社は、利用者が暴力団等反社会的勢力に所属若しくは該当する、又は関与していると判断した場合、当該利用者に事前に通知等を行うことなく、本サービスの利用の全部又は一部の中止等の適切な措置を講じることがあります。

### 第８条（サービスの変更・追加・廃止）
- 当社は、次のいずれかに該当する場合には、利用者に事前に通知することなく、本サービスの利用の全部又は一部を停止又は中断することができるものとします。
  - 本サービスにかかるコンピューター・システムの点検又は保守作業を定期的又は緊急に行う場合
  - コンピューター、通信回線等が事故により停止した場合
  - 火災、停電、天災地変等の不可抗力により本サービスの運営ができなくなった場合
  - その他、当社が停止又は中断を必要と判断した場合
- 当社は、当社の都合により、本サービスの提供を終了することができます。この場合、当社は利用者に事前に通知するものとします。
- 当社は、本条により当社が行った措置に基づき利用者に生じた損害について当社の故意又は重大な過失がある場合を除き、一切の責任を負いません。また、当社は、理由の如何を問わず、利用者に事前に連絡することなく、本サービスの内容の全部又は一部を変更又は追加することができるものとします。

### 第９条（設備の負担等）
- 本サービスの提供を受けるために必要な、コンピューター、ソフトウェアその他の機器、通信回線その他の通信環境等の準備及び維持は、利用者の費用と責任において行うものとします。利用者は自己の本サービスの利用環境に応じて、コンピューター・ウィルスの感染の防止、不正アクセス及び情報漏洩の防止等のセキュリティ対策を自らの費用と責任において講じるものとします。
- 利用者は、本サービスの利用開始に際し又は本サービスの利用中に、当社ウェブサイトからのダウンロードその他の方法によりソフトウェア等を利用者のコンピューター等にインストールする場合には、利用者が保有する情報の消滅若しくは改変又は機器の故障、損傷等が生じないよう十分な注意を払うものとし、当社は利用者に発生したかかる損害について、当社の故意又は重大な過失がある場合を除き、一切責任を負わないものとします。
- 当社は、利用者が送受信したメッセージその他の情報を運営上一定期間保存していた場合であっても、かかる情報を保存する義務を負うものではなく、当社はいつでもこれらの情報を削除できるものとします。なお、当社はかかる情報の削除に基づき利用者に生じた損害について、当社の故意又は重大な過失がある場合を除き、一切の責任を負いません。

### 第10条（本サービス等に関する権利）
- 当社ウェブサイト及び本サービスに関する所有権及び知的財産権（本サービスのコンテンツに関する知的財産権を含みますが、これに限られません。）は全て当社、契約医療機関又はその他の第三者に帰属しており、本規約に定める登録に基づく本サービスの利用許諾は、本規約において明示されているものを除き、当社ウェブサイト又は本サービスに関する当社又は当社にライセンスを許諾している者の知的財産権の譲渡又は使用許諾を意味するものではありません。
- 利用者又は連携診療所は、データ等について、自らがデータ保存その他送信する適法な権利を有していること及びデータ等が第三者の権利を侵害していないことを当社に表明し保証するものとします。
- 本サービスで言及されている当社及び契約医療機関の社名、製品名及びサービス名は、それぞれ当社及び契約医療機関の登録商標もしくは商標です。本サービスで表示されている商標を所有者の許可なしに使用する権利を与えたりライセンスすることを黙示的に認めるものではありません。

### 第11条（保証の否認及び免責）
- 当社は、利用者による本サービスの利用に関し、契約医療機関又は連携診療所が提供する情報等の正確性、有用性、完全性等について何らの保証をしないものとします。
- 当社は、利用者による本サービスの利用に関し、次の各号に掲げることを保証しないものとします
  - 本サービスが中断しないこと
  - 本サービスにエラーが生じないこと
  - 本サービスの利用に関し通信回線等の障害がないこと
  - 本サービス提供ページに対する不正アクセス・ハッキング等のサイバー攻撃がないこと
- 本サービスの利用、変更、中断、中止などにより発生した利用者の損害すべてに対し、当社及び契約医療機関は一切の責任を負わないものとします。また、本サービスの利用により利用者または第三者が被った損害に対し、当社及び契約医療機関はいかなる責任も負わないものとし、当社及び契約医療機関に損害を賠償する義務は一切ないものとします。
- 本サービスを利用するにあたり使用する通信機器、ソフトウェアおよびこれらに付随して必要となる全ての機器との互換性を確保するために、本サービスが管理する設備、システムもしくはソフトウェアを改造、変更または追加、本サービスの利用方法または情報の提供方法を変更する義務を当社及び契約医療機関は負わないものとします。
- 本サービスを利用するにあたり、連携診療所が登録した患者情報を、医療行為に必要な範囲を超えて利用した場合、又は当該患者以外の第三者に開示・提供した場合に損害が生じたとしても、当社の故意又は重大な過失がある場合を除き、当社は一切の責任を負いません。
- 本サービスの利用及び契約医療機関が提供する内容を起因とする利用者の不利益または第三者とのトラブル等に関して、当社の故意又は重大な過失がある場合を除き、当社は一切その責任を負わないものとします。
- 当社は、次の各号に該当する記載を発見した場合、予告なく、当該記載を削除する場合があります。
  - 本規約に反する記載
  - 公序良俗に反する記載
  - 有害なプログラム・スクリプトなどを含む記載
  - 他人の名誉・信用を害する記載
  - 本サービスの運営を妨げる記載
  - その他、当社が不適切であると判断した記載
- 当社は、本サービスに関連して利用者が被った損害について、当社の故意又は重大な過失がある場合を除き、一切賠償の責任を負いません。

### 第12条（本規約等の変更および効力発生時期について）
- 当社は、以下の場合に、当社の裁量により、本規約（本サービスに関するルール、諸規定等を含みます。以下本項において同じ。）を変更できるものとします。
  - 本規約の変更が、利用者の一般の利益に適合するとき
  - 本規約の変更が、契約をした目的に反せず、かつ、変更の必要性、変更後の内容の相当性、変更の内容その他の変更に係る事情に照らして合理的なものであるとき
- 当社は、前項による本規約の変更にあたり、本規約を変更する旨及び変更後の本規約の内容とその効力発生日を本サービス内に公表するものとし、当該変更後の本規約の効力発生日以降に利用者が本サービスを利用した場合又は変更後の本規約の効力発生日までに登録取消の手続をとらなかった場合には、利用者は、本規約の変更に同意したものとみなします。

### 第13条（連絡/通知）
本サービスに関する問い合わせその他利用者から当社に対する連絡又は通知、及び本規約の変更に関する通知その他当社から利用者に対する連絡又は通知は、当社の定める方法で行うものとします。

### 第14条（本規約の譲渡等）
- 利用者は、当社の書面による事前の承諾なく、利用契約上の地位又は本規約に基づく権利若しくは義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできません。
- 当社は本サービスにかかる事業を第三者に譲渡（事業譲渡、会社分割その他態様の如何を問わないものとします。）した場合には、当該譲渡に伴い利用契約上の地位、本規約に基づく権利及び義務並びに利用者の登録情報その他の情報を当該譲渡の譲受人に譲渡することができるものとし、利用者は、かかる譲渡につき本項において予め同意したものとします。

### 第15条（完全合意）
本規約は、本規約に含まれる事項に関する当社と利用者との完全な合意を構成し、口頭又は書面を問わず、本規約に含まれる事項に関する当社と利用者との事前の合意、表明及び了解に優先します。

### 第16条（分離可能性）
本規約のいずれかの条項又はその一部が、消費者契約法その他の法令等により無効又は執行不能と判断された場合であっても、当該条項又は一部以外の残りの部分は、継続して効力を有するものとします。当社及び利用者は、当該無効又は執行不能の条項又は部分を適法とし執行力を持たせるために必要な範囲で修正し、当該無効又は執行不能な条項又は部分の趣旨並びに法律的及び経済的に同等の効果が確保されるように努めるものとします。

### 第17条（存続規定）
第5条、第6条第2項、第8条第3項、第9条第2項及び第3項、第10条、第11条から第19条までの規定は本サービスの利用終了後も有効に存続するものとします。

### 第18条（準拠法及び管轄裁判所）
本規約は日本法に準拠し、本規約に起因し又は関連する一切の紛争については、東京地方裁判所又は東京簡易裁判所を第一審の専属的合意管轄裁判所とします。

### 第19条（協議解決）
当社及び利用者は、本規約に定めのない事項又は本規約の解釈に疑義が生じた場合には、互いに信義誠実の原則に従って協議の上速やかに解決を図るものとします。
`;

  render () {
    return (<React.Suspense fallback={ <MnLoading/> }>
      <Layout state={this.props}>
        <div className="p-container p-menus">
          <div className="l-conatiner">
            <h4 className="w90p c-mn-title-2 ta-c">Hospital Manager（地域連携）利用規約</h4>
            <div className="p-container--content p-container--md">
              <ReactMarkdown source={this.text} escapeHtml={true}/>
            </div>
            <div className="p-container--card ta-c">
              <SimpleFormat text="2024年2月29日制定"/>
            </div>
          </div>
        </div>
      </Layout>
    </React.Suspense>);
  }
}
